import { createAction } from "@ngrx/store";


export const showHeader = createAction('[UI] Show header');
export const hideHeader = createAction('[UI] Hide header');